import styled, { keyframes } from "styled-components";

const sliding = keyframes`
    0% {
      left: -40%;
    }
    50% {
      left: 90%;
    }
    100% {
      left: -50%;
    }
`;
const ProcessingAnimation = styled.div`
  width: 100%;
  position: relative;
  height: 1px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.base3};

  &:after {
    content: "";
    height: 1px;
    position: absolute;
    width: 50%;
    background-color: ${({ theme }) => theme.colors.primary1};
    animation: ${sliding} 3s linear infinite;
  }
`;

export default ProcessingAnimation;
